var arrayWithoutHoles = require("./arrayWithoutHoles");

var iterableToArray = require("./iterableToArray");

var nonIterableSpread = require("./nonIterableSpread");

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray;


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/helpers/builtin/toConsumableArray.js
// module id = 128
// module chunks = 0